import React from 'react';
import './NotFound.scss';

const NotFound = () => (
        <h1>NotFound</h1>
    )

export default NotFound;